import { AppRoute } from '@agentselly/immodossier-shared';
import { useLinkProps } from '@tanstack/react-router';
import { Waitlist } from '@clerk/clerk-react';
import { useTheme } from '~/context/ThemeContext';
import { dark } from '@clerk/themes';

export function LegacyWaitlistBody() {
  const { resolvedTheme } = useTheme();
  const { href: signInUrl } = useLinkProps({
    to: AppRoute.$LANG_$COMPANYID_INDEX as any,
  });

  return (
    <Waitlist
      afterJoinWaitlistUrl="https://www.agentselly.ch/?utm_source=clerk_waitlist&utm_medium=clerk_waitlist&utm_campaign=redirect&utm_content=%24%7B1%7D"
      signInUrl={signInUrl}
      appearance={{
        baseTheme: resolvedTheme === 'dark' ? dark : undefined,
        elements: {
          rootBox: 'mx-auto',
        },
      }}
    />
  );
}
